module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeWithoutSubmit),
      expression: "closeWithoutSubmit"
    }],
    staticClass: "user-phonenumber"
  }, [_c('transition', {
    attrs: {
      "name": "fadeInRight",
      "mode": "out-in"
    }
  }, [(!_vm.isEdit) ? _c('div', {
    key: "showNumber",
    staticClass: "current-number",
    on: {
      "click": _vm.setEdit
    }
  }, [(!_vm.isPendingConfirmation && _vm.number.length < 8) ? _c('p', {
    staticClass: "pointer link"
  }, [_vm._v(_vm._s(_vm.$t('vue2.sms.add_number')))]) : _vm._e(), _vm._v(" "), (_vm.number.length > 7) ? _c('div', {
    staticClass: "current-number__number flex align-center"
  }, [_vm._v("\n        " + _vm._s(_vm.number) + "\n      ")]) : _vm._e()]) : _c('div', {
    key: "editNumber",
    staticClass: "add-number"
  }, [_c('div', {
    staticClass: "input-group hint",
    class: _vm.hintClass,
    attrs: {
      "aria-label": _vm.$t('vue2.sms.number_must_be_8_digits')
    }
  }, [_c('div', {
    staticClass: "flex-group"
  }, [_c('div', {
    staticClass: "flag__input-lookalike active-country"
  }, [_c('img', {
    staticClass: "country-flag",
    attrs: {
      "src": _vm.activeCountry.flag,
      "alt": ""
    }
  }), _vm._v("+" + _vm._s(_vm.activeCountry.countryCode) + "\n            "), _c('DDropdown', [_c('span', {
    staticClass: "icon-arrow-down5",
    attrs: {
      "slot": "d-dropdown__icon"
    },
    slot: "d-dropdown__icon"
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.countries), function(country) {
    return _c('li', {
      key: country.countryCode,
      staticClass: "country-select__item",
      on: {
        "click": function($event) {
          return _vm.setActiveCountry(country)
        }
      }
    }, [_c('div', {
      staticClass: "country-select__item__name"
    }, [_c('img', {
      staticClass: "country-flag",
      attrs: {
        "src": country.flag,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(country.name))])]), _vm._v("\n                  +" + _vm._s(country.countryCode) + "\n                ")])
  }), 0)])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    ref: "inputfield",
    staticClass: "input_phonenumber",
    class: {
      'input--error': _vm.showWarning
    },
    attrs: {
      "type": "phonenumber",
      "autocomplete": "off",
      "placeholder": _vm.$t('vue2.sms.add_number')
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "keypress": function($event) {
        return _vm.inputKeypress($event)
      },
      "keyup": [_vm.inputKeyup, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "submit", undefined, $event.key, undefined)) { return null; }
        return _vm.keyPressEnter.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeWithoutSubmit.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isNumberChanged) ? _c('button', {
    staticClass: "submit-button",
    class: [{
        'submit-button--disabled': !_vm.isValidNumber && !_vm.isNumberBeingDeleted
      },
      {
        'submit-button--delete': _vm.isNumberBeingDeleted
      }
    ],
    attrs: {
      "aria-label": _vm.$t('vue2.sms.number_must_be_8_digits')
    },
    on: {
      "click": _vm.submitNumber,
      "mouseenter": _vm.onMouseOver,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNumberBeingDeleted),
      expression: "isNumberBeingDeleted"
    }]
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNumberBeingDeleted),
      expression: "!isNumberBeingDeleted"
    }]
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _c('button', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        return _vm.closeWithoutSubmit('button')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.close')) + "\n          ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e471144!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/SmsAddNumber.vue
// module id = 1836
// module chunks = 1